<!--https://material.angular.io/components/dialog/overview-->
<h1 mat-dialog-title [innerHTML]="data.title"></h1>
<div mat-dialog-content [innerHTML]="data.content"></div>
<div mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</div>
